import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

const OpenButton = styled(Button, { shouldForwardProp: (prop) => prop !== "hidden" })(({ hidden }) => ({
  zIndex: 1,
  ...(hidden && { display: "none" })
}))

export { OpenButton };
